'use client';
import { ICONS } from '@qlevr/shared/constants';
import { Tooltip } from 'flowbite-react';
import IconRenderer from '../icons/icon-renderer.component';
import { cn } from '@qlevr/shared/utilities';

interface ProductPromotionInfoTooltipProps {
  infoMessage: string;
  className?: string;
}

export function ProductPromotionInfoTooltip({ infoMessage, className }: ProductPromotionInfoTooltipProps) {
  return (
    <Tooltip className="w-max bg-white text-black shadow-md" content={infoMessage} arrow={false} trigger="hover">
      <div
        className={cn(
          'cursor-pointer rounded-full p-1 transition-colors',
          'hover:bg-black hover:bg-opacity-10',
          'focus:bg-black focus:bg-opacity-10',
          className,
        )}
        tabIndex={0}
        role="button"
        aria-label="Show additional information"
      >
        <IconRenderer icon={ICONS.alertCircle} className="h-4 w-4 opacity-75" />
      </div>
    </Tooltip>
  );
}
